import PropTypes from 'prop-types'
import React from 'react'
import { ModalBody } from 'reactstrap'

import { Modal, ModalHeader } from '../../generic'

import Share from './Share'

const ModalShare = ({ isOpen = true, onClose, ...params }) => (
  <Modal isOpen={isOpen} toggle={onClose} backdrop fade className='modal-share'>
    <ModalHeader onClose={onClose}>Teilen</ModalHeader>
    <ModalBody>
      <Share onClose={onClose} {...params} />
    </ModalBody>
  </Modal>
)

ModalShare.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired
}

export default ModalShare
